import React from "react";

export const FormContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen p-16px sm:px-30 bg-auth-bg bg-auth-gradient flex justify-center items-center">
      <div className="flex h-full rounded-xl px-24px py-32px sm:px-32px sm:py-40px bg-white max-w-[400px] w-full mx-auto my-auto">
        {children}
      </div>
    </div>
  );
};
